import { ProductDetailMembersipNudge } from '~/domains/plusMembership/components/Nudges';
import { useMembershipStatus } from '~/domains/plusMembership/hooks/useMembershipStatus';
import { useProductDetailsNudge } from '~/domains/plusMembership/queries';
import type { OAISchema } from '~/types/openapi';
import { isMoreThan } from '~/utils/number';

import { DefaultProductPrice } from './DefaultProductPrice';
import { DiscountBenefitCard } from './DiscountBenefitCard';
import { MembershipTrialPrice } from './MembershipTrialPrice';
import { StandardWithBonuspackPrice } from './StandardWithBonuspackPrice';

type Props = {
  data: OAISchema['MarketProductDetailsResponseV2'];
};

export function ProductPriceInfo({ data }: Props) {
  const { isMembershipSubscribeServiceAvailable, isBonusPackRegistered } =
    useMembershipStatus();
  const { data: nudgeData } = useProductDetailsNudge(data.offerId!);

  //  3. 멤버십 + 보너스팩 가입자만 노출
  if (isBonusPackRegistered) {
    return <StandardWithBonuspackPrice data={data} />;
  }

  // 2. 플멤 가입이 가능한 경우 + 플멤 할인가가 일반 쿠폰가보다 큰 경우
  const isMembershipTrialPrice =
    isMembershipSubscribeServiceAvailable &&
    isMoreThan(data.totalDiscountedPrice, nudgeData?.details[0]?.nudgeAmount);

  if (isMembershipTrialPrice) {
    return <MembershipTrialPrice data={data} />;
  }

  return (
    <>
      <DefaultProductPrice data={data} />

      {/* 할인 정보 */}
      {!!data.discountResult?.maximumDiscountAmount && (
        <DiscountBenefitCard data={data} />
      )}
      <ProductDetailMembersipNudge />
    </>
  );
}
